<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 个人中心 > 修改密码
			</div>
			<div class="contentLeft">
				<div class="con">
					<div class="left">
						<div class="tab-container tab">
							<ul>
								<li v-for="(item, index) in tabList" :key="index"
									:class="{ active: currentTabIndex == index }" @click="goOther(index)">
									{{ item }}
								</li>
							</ul>
						</div>
						<div class="tit">修改密码</div>
						<div class="mod-pwd" v-if="!modPhonePwdFlag && !modPwdFlag">
							<div class="img">
								<img src="../../../static/images/smy/yanzheng.png" />
								<p>身份验证</p>
							</div>
							<div class="item">
								<div class="line" @click="modPhonePwd">
									<div class="line-left">
										<img src="../../../static/images/smy/shoujihao.png" />
									</div>
									<div class="line-right">
										<p>手机号码验证</p>
										<p v-if="loginInfo.phone">通过{{this.loginInfo.phone.substr(0, 3) + '****' + this.loginInfo.phone.substr(this.loginInfo.phone.length - 4)}}接收短信验证</p>
									</div>
								</div>
								<div class="line" @click="modPwd">
									<div class="line-left">
										<img src="../../../static/images/smy/mima.png" />
									</div>
									<div class="line-right">
										<p>通过原密码验证</p>
										<p>通过认证旧密码来设置新密码</p>
									</div>
								</div>
							</div>
						</div>

						<div class="tab-con" v-if="modPhonePwdFlag">
							<el-form :model="phoneForm" ref="phoneForm"  :rules="phoneRules" class="demo-ruleForm">
								<el-form-item label="手机号" prop="phone">
									<el-input disabled v-model="phoneForm.phone" placeholder="请输入手机号码">

									</el-input>
									<span class="getCode" plain :style="{'color':loginCodeInfo.getCodeBtnColor}"
										@click="getLoginCode">{{loginCodeInfo.getCodeText}}</span>
								</el-form-item>
								<el-form-item label="验证码" prop="code">
									<el-input v-model="phoneForm.code" placeholder="请输入验证码"></el-input>
								</el-form-item>
								<el-form-item label="新密码" prop="loginPassword">
									<el-input type="password" v-model="phoneForm.loginPassword"
										placeholder="请输入6-20位登录密码"></el-input>
								</el-form-item>
								<el-form-item label="确认密码" prop="confirmPassword">
									<el-input type="password" v-model="phoneForm.confirmPassword" placeholder="请确认密码">
									</el-input>
								</el-form-item>
								<el-form-item class="textCenter">
									<span class="back" @click="phoneCancel">取消</span>
									<span class="register" @click="phoneSubmitForm('phoneForm')">确定</span>

								</el-form-item>
							</el-form>
						</div>


						<div class="tab-con" v-if="modPwdFlag">
							<el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm">
								<el-form-item label="原密码" prop="oldPassword">
									<el-input type="password" v-model="ruleForm.oldPassword" placeholder="请输入原密码">
									</el-input>
								</el-form-item>
								<el-form-item label="新密码" prop="loginPassword">
									<el-input type="password" v-model="ruleForm.loginPassword"
										placeholder="请输入6-20位登录密码"></el-input>
								</el-form-item>
								<el-form-item label="确认密码" prop="confirmPassword">
									<el-input type="password" v-model="ruleForm.confirmPassword" placeholder="请确认密码">
									</el-input>
								</el-form-item>
								<el-form-item class="textCenter">
									<span class="back" @click="cancel">取消</span>
									<span class="register" @click="submitForm('ruleForm')">确定</span>

								</el-form-item>
							</el-form>
						</div>



					</div>
					<div class="right">
						<div class="tit">用户信息</div>
						<div class="top">
							<div class="top-con">
								<img src="../../../static/images/touxiang.png" />
								<p class="name">{{loginInfo.username}}</p>
								<p>
									<span>机构：</span>
									<span>{{loginInfo.hospitalName?loginInfo.hospitalName:'暂无'}}</span>
								</p>
								<p>
									<span>科室：</span>
									<span>{{loginInfo.departmentName?loginInfo.departmentName:'暂无'}}</span>
								</p>
							</div>
						</div>
						<div class="bottom">
							<div class="info">最近登录信息</div>
							<div class="loginInfo">
								<span>登录时间</span>
								<span>{{loginInfo.loginTime}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NProgress from "nprogress";
	// 手机号验证规则
	const validatePhon = (rule, value, callback) => {
		if (value === '') {
			callback(new Error('请输入手机号码'))
		} else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
			callback(new Error("请输入正确的手机号码"))
		} else {
			callback()
		}
	}

	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.loginPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.phoneForm.loginPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				phoneForm: {
					phone: '',
					code: '',
					loginPassword: '', //登录密码
					confirmPassword: '', //确认密码
				},
				ruleForm: {
					oldPassword: '',
					loginPassword: '', //登录密码
					confirmPassword: '', //确认密码
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}, ],
					loginPassword: [{
							required: true,
							message: '请输入新密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'change'
						}
					],
					confirmPassword: [{
							required: true,
							message: '请输入确认密码',
							trigger: 'blur'
						},
						{
							validator: validatePass,
							trigger: 'change'
						}
					],
				},
				phoneRules: {
					phone: [{
							required: true,
							validator: validatePhon,
							trigger: 'blur',
						},
						{
							pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						},
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
					loginPassword: [{
							required: true,
							message: '请输入登录密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '长度在 6 到 20 个字符',
							trigger: 'change'
						}
					],
					confirmPassword: [{
							required: true,
							message: '请输入确认密码',
							trigger: 'blur'
						},
						{
							validator: validatePass2,
							trigger: 'change'
						}
					],
				},
				sexArr: [{
						images: require('../../../static/images/mzy/man_1.png'),
						activeImages: require('../../../static/images/mzy/man_2.png'),
					},
					{
						images: require('../../../static/images/mzy/woman_1.png'),
				 	activeImages: require('../../../static/images/mzy/woman_2.png'),
					},
				],
				sexCunrentIndex: 0,
				loginInfo: {},
				tabList: ["个人中心", "修改密码"],
				currentTabIndex: 1,
				modPwdFlag: false,
				modPhonePwdFlag: false,
				loginCodeInfo: {
					holdTime: 60,
					getCodeText: '获取验证码',
					getCodeBtnColor: '#679FF6',
					getCodeisWaiting: false,
					codeTimer: null,
				}

			}
		},
		filters: {
			//手机号过滤器
			phoneFilter(val) {
				let reg = /^(.{3}).*(.{4})$/;
				return val.replace(reg, "$1****$2");
			},

			//邮箱过滤器
			mailboxFileter(val) {
				let reg = /^(.{3}).*(.{9})$/;
				return val.replace(reg, "$1****$2");
			},
		},
		methods: {
			//路由切换
			goOther(index) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/personalCenter/personalCenter",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/personalCenter/modifyPassword",
					});
				}
			},

			//通过手机号修改密码
			modPhonePwd() {
				this.modPhonePwdFlag = true;
			},
			//通过原密码修改密码
			modPwd() {
				this.modPwdFlag = true;

			},

			//获取验证码
			getLoginCode() {
				if (this.loginCodeInfo.getCodeisWaiting) {
					return false
				}
				this.loginCodeInfo.getCodeisWaiting = true;
				this.getDoctorSms(this.phoneForm.phone);
			},

			//获取验证码
			getDoctorSms(phone) {
				this.$applicationJson('business/user/sms', {
					phone: phone,
					type: 0
				}).then(res => {
					if (res.data.code == 200) {
						this.$message.success("验证码已发送");
						this.loginCodeInfo.getCodeisWaiting = true;
						this.setTimer(this.loginCodeInfo); //调用定时器方法
						
						NProgress.done();
					} else {
						this.loginCodeInfo.getCodeisWaiting = false;
						NProgress.done();
					}

				}).catch(Error => {
					NProgress.done();
				})
			},

			//定时器
			setTimer(registerCodeInfo) {
				registerCodeInfo.getCodeText = "重新获取(60)";
				registerCodeInfo.codeTimer = setInterval(() => {
					if (registerCodeInfo.holdTime <= 0) {
						registerCodeInfo.getCodeisWaiting = false;
						registerCodeInfo.getCodeText = "获取验证码";
						registerCodeInfo.getCodeBtnColor = '#001D7F';
						clearInterval(registerCodeInfo.codeTimer); //清除该函数
						return; //返回前面
					}
					registerCodeInfo.getCodeBtnColor = '#679FF6';
					registerCodeInfo.getCodeText = "重新获取(" + registerCodeInfo.holdTime + ")"
					registerCodeInfo.holdTime--;
				}, 1000)
			},
			//手机取消
			phoneCancel() {
				this.phoneForm = {
					phone: '',
					code: '',
					loginPassword: '', //登录密码
					confirmPassword: '', //确认密码
				}
				this.modPhonePwdFlag = false;
			},
			//通过手机号修改密码提交
			phoneSubmitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.doctorSmsVerify(this.phoneForm);
					} else {
						console.log("error submit!!");
						return false;
					}
				});
				/* this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$applicationJson('/business/user/editPassword', {
						  newPass: this.ruleForm.loginPassword,
						  oldPass: this.ruleForm.oldPassword,
						  
						}).then(
						  res => {
						   //console.log(res)
						    if (res.data.code == 0) {
								
								this.$confirm('密码修改成功，请重新登录', '提示', {
								  confirmButtonText: '确定',
								  showCancelButton:false,
								  showClose:false,
								  callback: action => {
									this.$router.push('/login/login')
								  }
								});
						    }else{
								this.$message.error(res.data.msg);
							}
						  }
						).catch(Error => {
						  this.$message.error('网络异常');
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				 */
			},

			//验证码验证
			doctorSmsVerify(info) {
				this.$applicationJson("/business/user/sms/verify", {
						phone: info.phone,
						captcha: info.code,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.register();
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						console.log(Error);
					});
			},
			register() {
				this.$applicationJson("/business/user/reset", {
						captcha: this.phoneForm.code,
						username: this.loginInfo.username,
						password: this.phoneForm.loginPassword,
						phone: this.phoneForm.phone,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.registerFlag = true;
							this.$message.success("修改成功");
							this.$confirm('密码修改成功，请重新登录', '提示', {
								confirmButtonText: '确定',
								showCancelButton: false,
								showClose: false,
								callback: action => {
									this.$router.push('/login/login')
								}
							});
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//原密码修改取消
			cancel() {
				this.ruleForm = {
					oldPassword: '',
					loginPassword: '', //登录密码
					confirmPassword: '', //确认密码
				}
				this.modPwdFlag = false;
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$applicationJson('/business/user/editPassword', {
							newPass: this.ruleForm.loginPassword,
							oldPass: this.ruleForm.oldPassword,

						}).then(
							res => {
								//console.log(res)
								if (res.data.code == 0) {

									this.$confirm('密码修改成功，请重新登录', '提示', {
										confirmButtonText: '确定',
										showCancelButton: false,
								 	showClose: false,
										callback: action => {
											this.$router.push('/login/login')
										}
									});
								} else {
									this.$message.error(res.data.msg);
								}
							}
						).catch(Error => {
							this.$message.error('网络异常');
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			phoneFilter(val) {
				let reg = /^(.{3}).*(.{4})$/;
				return val.replace(reg, "$1****$2");
			},
		},
		created() {
			this.$nextTick(() => {
				this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				this.phoneForm.phone = this.loginInfo.phone;
				
			})
		},
	}
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					width: 100%;
					height: calc(100% - 10px);
				}

				.left {
					width: 65%;
					//margin:20px 30px;
					//margin-left: 1%;
					float: left;
					border: 1px solid #e5e5e5;
					border-radius: 8px;
					height: 100%;
					background: #fff;

					.tab-container {
						ul {
							margin-left: 20px;
							margin-top: 10px;
							height: auto;
						}
					}

					.tit {
						background: #f5f5f5;
						line-height: 48px;
						height: 48px;
						font-size: 18px;
						padding-left: 23px;
						width: calc(100% - 23px);
						color: rgba(76, 81, 89, 1);
						display: none;
					}

					.mod-pwd {
						overflow: hidden;
						width: calc(100% - 140px);
						margin: 30px 70px;

						.img {
							text-align: center;

							img {
								width: 80px;
								margin: 0 auto;
							}

							p {
								color: #2E3034;
								font-size: 16px;
								margin-top: 5px;
							}
						}

						.item {
							margin-top: 40px;
							width: 100%;

							.line {
								height: 80px;
								background: #FFFFFF;
								border-radius: 8px;
								border: 1px solid #C9CBD1;
								width: 80%;
								margin-top: 20px;
								cursor: pointer;

								.line-left {
									float: left;

									img {
										width: 24px;
										margin: 28px 20px;
									}
								}

								.line-right {
									p {
										color: #2E3034;
										line-height: 26px;
										height: 26px;
										font-size: 14px;

										&:nth-child(1) {
											margin-top: 14px;
										}

										&:nth-child(2) {
											color: #8D9099;
										}
									}
								}
							}
						}
					}

					.tab-con {
						overflow: hidden;
						width: 480px;
						margin: 50px 100px;
						:deep(.el-form-item){
							margin-bottom: 14px;
							display: inline-block;
							width:440px;
							float: left;
							:deep(.el-input){
								margin-left: 0;
								position: relative;
								.el-input__inner{
									width: 400px;
								}
							}
							.getCode{
								position: absolute;
								left: 310px;
								border-left: 1px solid #eee;
								padding-left: 20px;
								cursor: pointer;						
							}
						}
						
						.nameSex {
							overflow: hidden;
							width: 100%;

							ul {
								float: left;

								li {
									float: left;
									cursor: pointer;

									img {
										float: left;
										width: 30px;
										margin-top: 3px;
										margin-right: 10px;
										margin-bottom: 20px;

									}
								}
							}

						}

						.sex {
							width: 44%;
						}

						.textCenter {
							text-align: center;
							margin-top: 20px;
							width: 250px;
							margin: 20px auto;
						}
					}

					.back {
						display: inline-block;
						color: #fff;
						height: 40px;
						line-height: 40px;
						border-radius: 3px;
						padding: 0 20px;
						cursor: pointer;
						background: #fff;
						border: 1px solid #eee;
						color: #333;
						margin-right: 20px;
						float: none;
					}

					.register {
						padding: 0 20px;
						background: #679FF6;
					}
				}

				.right {
					width: 33%;
					//margin:20px 30px;
					//margin-left: 5%;
					float: right;
					border: 1px solid #e5e5e5;
					border-radius: 8px;
					height: 100%;
					background: #fff;

					.tit {
						background: #f5f5f5;
						line-height: 48px;
						height: 48px;
						font-size: 18px;
						padding-left: 23px;
						width: calc(100% - 23px);
						color: rgba(76, 81, 89, 1);
					}

					.top {
						width: 100%;

						.top-con {
							img {
								margin: 30px auto;
								width: 100px;
							}

							width: 100%;

							.name {
								text-align: center;
								color: #13171D;
								font-size: 36px;
								line-height: 54px;
							}

							p {
								line-height: 24px;
								width: 200px;
								margin: 0 auto;
								font-size: 16px;
								color: #4C5159;
								margin-top: 10px;
								overflow: hidden;

								span {
									display: inline-block;
									float: left;

									&:nth-child(1) {
										width: 60px;
										text-align: center;
									}

									&:nth-child(2) {
										width: 140px;
										white-space: nowrap;
										overflow: hidden;
										text-overflow: ellipsis;
									}
								}
							}
						}
					}

					.bottom {
						width: 100%;
						margin-top: 60px;

						.info {
							color: #4C5159;
							line-height: 46px;
							font-size: 18px;
							padding-left: 23px;
							background: #F7F7F7;
							margin-bottom: 20px;
						}

						.loginInfo {
							border-bottom: 1px solid #e5e5e5;
							height: 36px;
							line-height: 36px;
							margin: 0 23px;

							span {
								color: #4C5159;
								font-size: 14px;

								&:nth-child(1) {
									float: left;
								}

								&:nth-child(2) {
									float: right;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
